import jQuery from "jquery";
Object.assign(window, {$: jQuery, jQuery})

// @ts-ignore
if (import.meta.env.MODE === 'test' || window.environment === 'test') {
  console.log('turning off jquery animations')
  $.fx.off = true;
}